import React from 'react';

const FeatureFlagsContext = React.createContext<Record<string, boolean>>({});

export default FeatureFlagsContext;
